import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyA0l4NLCQ-4DO5Uvvr6ufSXCR11xmydcy8",
  authDomain: "fiumepo-705fb.firebaseapp.com",
  projectId: "fiumepo-705fb",
  storageBucket: "fiumepo-705fb.appspot.com",
  messagingSenderId: "745763682854",
  appId: "1:745763682854:web:011531e5bc16b320abc4e7",
  measurementId: "G-DXKBZS6X6V",
};

const app = initializeApp(firebaseConfig);

export { app };
